/**
 * Honest empty panel for Provider screens that have no live API yet.
 */
export function ApiUnavailablePanel({ title, children }) {
  return (
    <section className="rounded-2xl border border-eorig-border bg-white p-6 shadow-eorig-card">
      {title ? (
        <h2 className="text-sm font-semibold text-eorig-ink">{title}</h2>
      ) : null}
      <p className={`text-sm leading-relaxed text-eorig-muted ${title ? 'mt-2' : ''}`}>
        {children}
      </p>
    </section>
  );
}
